import { render, staticRenderFns } from "./cash-transfer-report.vue?vue&type=template&id=30bc1cc7&"
import script from "./cash-transfer-report.vue?vue&type=script&lang=js&"
export * from "./cash-transfer-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports